export enum TradePointBrandEnum {
    CoffeeMachine,
    YaiThai,
    CrossCulture,
    Invigorate,
}
